import { type FC, type ReactNode, useEffect, useRef, useState } from "react";

import { Tooltip, TooltipPlacementTypes } from "@snapchat/snap-design-system";

import { temporaryTooltipHandler } from "../../effects";

interface TemporaryTooltipProps {
    content: ReactNode;
    callbackAction: () => void;
    children?: ReactNode;
}

export const TemporaryTooltip: FC<TemporaryTooltipProps> = ({ content, callbackAction, children }) => {
    const [visible, setVisible] = useState(false);
    const buttonRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        const toggleSubscription = temporaryTooltipHandler(buttonRef.current, callbackAction, setVisible);

        return () => {
            toggleSubscription?.unsubscribe();
        };
    }, [buttonRef, setVisible, callbackAction]);

    return (
        <Tooltip content={content} visible={visible} placement={TooltipPlacementTypes.TOP}>
            <span ref={buttonRef}>{children}</span>
        </Tooltip>
    );
};
